"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LOADER_BACKGROUND_COLOR = exports.ADMIN_BAR_HEIGHT = exports.TABLE_BODY_ROW_HEIGHT = exports.TABLE_HEADER_ROW_HEIGHT = exports.OVERLAY_BACKGROUND_COLOR = exports.MAX_POPOVER_MOBILE_WIDTH = exports.MAX_CONTAINER_WIDTH = exports.HEADER_HEIGHT = exports.SIDEBAR_ITEM_HEIGHT = exports.SIDEBAR_WIDTH = exports.MENU_ITEM_HEIGHT = exports.ICON_DEFAULT_SIZE = exports.ICON_COMPACT_SIZE = exports.CARD_SHADOW = exports.APPBAR_SHADOW = exports.SPACING_UNIT = exports.BORDER_RADIUS = exports.BREAKPOINTS = void 0;

var _createBreakpoints = _interopRequireDefault(require("@material-ui/core/styles/createBreakpoints"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BREAKPOINTS = (0, _createBreakpoints.default)({});
exports.BREAKPOINTS = BREAKPOINTS;
var BORDER_RADIUS = 3;
exports.BORDER_RADIUS = BORDER_RADIUS;
var SPACING_UNIT = 8;
exports.SPACING_UNIT = SPACING_UNIT;
var APPBAR_SHADOW = '0px 1px 8px 0px rgba(0, 0, 0, 0.06),0px 3px 4px 0px rgba(0, 0, 0, 0.06),0px 3px 3px -2px rgba(0, 0, 0, 0.06)';
exports.APPBAR_SHADOW = APPBAR_SHADOW;
var CARD_SHADOW = '0px 1px 5px 0px rgba(0, 0, 0, 0.06),0px 2px 2px 0px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06)';
exports.CARD_SHADOW = CARD_SHADOW;
var ICON_COMPACT_SIZE = 18;
exports.ICON_COMPACT_SIZE = ICON_COMPACT_SIZE;
var ICON_DEFAULT_SIZE = 24;
exports.ICON_DEFAULT_SIZE = ICON_DEFAULT_SIZE;
var MENU_ITEM_HEIGHT = 48;
exports.MENU_ITEM_HEIGHT = MENU_ITEM_HEIGHT;
var SIDEBAR_WIDTH = 250;
exports.SIDEBAR_WIDTH = SIDEBAR_WIDTH;
var SIDEBAR_ITEM_HEIGHT = 48;
exports.SIDEBAR_ITEM_HEIGHT = SIDEBAR_ITEM_HEIGHT;
var HEADER_HEIGHT = 56;
exports.HEADER_HEIGHT = HEADER_HEIGHT;
var MAX_CONTAINER_WIDTH = 1200;
exports.MAX_CONTAINER_WIDTH = MAX_CONTAINER_WIDTH;
var MAX_POPOVER_MOBILE_WIDTH = 260;
exports.MAX_POPOVER_MOBILE_WIDTH = MAX_POPOVER_MOBILE_WIDTH;
var OVERLAY_BACKGROUND_COLOR = 'rgba(255, 255, 255, 0.85)';
exports.OVERLAY_BACKGROUND_COLOR = OVERLAY_BACKGROUND_COLOR;
var TABLE_HEADER_ROW_HEIGHT = 56;
exports.TABLE_HEADER_ROW_HEIGHT = TABLE_HEADER_ROW_HEIGHT;
var TABLE_BODY_ROW_HEIGHT = 48;
exports.TABLE_BODY_ROW_HEIGHT = TABLE_BODY_ROW_HEIGHT;
var ADMIN_BAR_HEIGHT = 72;
exports.ADMIN_BAR_HEIGHT = ADMIN_BAR_HEIGHT;
var LOADER_BACKGROUND_COLOR = 'linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%)';
exports.LOADER_BACKGROUND_COLOR = LOADER_BACKGROUND_COLOR;
var _default = {
  adminHeaderHeight: ADMIN_BAR_HEIGHT,
  headerHeight: HEADER_HEIGHT,
  sidebarWidth: SIDEBAR_WIDTH,
  menuItemHeight: MENU_ITEM_HEIGHT,
  sidebarItemHeight: SIDEBAR_ITEM_HEIGHT,
  maxContainerWidth: MAX_CONTAINER_WIDTH,
  overlayBackgroundColor: OVERLAY_BACKGROUND_COLOR,
  maxPopoverMobileWidth: MAX_POPOVER_MOBILE_WIDTH,
  tableHeaderRowHeight: TABLE_HEADER_ROW_HEIGHT,
  tableBodyRowHeight: TABLE_BODY_ROW_HEIGHT,
  loaderBackground: LOADER_BACKGROUND_COLOR
};
exports.default = _default;